import { Tooltip } from 'antd';
import React from 'react';
import Icon, {
  CustomIconComponentProps
} from '@ant-design/icons/lib/components/Icon';
import { semanticTheme } from '@tools/ui/dime';
import { theme } from '@tools/ui-utils/theme.util';

export type SVGComponent = React.ComponentType<
  React.PropsWithChildren<
    CustomIconComponentProps | React.SVGProps<SVGSVGElement>
  >
>;

type IProps = {
  style?: React.CSSProperties;
  component: unknown;
  tooltip?: string;
};

const TableIcon: React.FC<React.PropsWithChildren<IProps>> = ({
  style,
  component,
  tooltip
}) => {
  const defaultStyle = {
    fontSize: semanticTheme.dime.fonts.sizes.base,
    marginLeft: 4,
    color: `${theme.colors.black}`,
    ...style
  };
  return (
    <Tooltip
      placement="top"
      title={tooltip}
      overlayStyle={{ whiteSpace: 'pre-line' }}
    >
      <span>
        <Icon component={component as SVGComponent} style={defaultStyle} />
      </span>
    </Tooltip>
  );
};

export default TableIcon;
